<template>
  <div class="hero-section">
    <div class="hero-container">
      <div class="text-section">
        <div class="bitcoin">
          <i class="fi fi-sr-flag"></i>

          <p class="bit-text">Let's start</p>
          <i class="fas fa-arrow-right"></i>
        </div>
        <h2 class="heading">
          Get started and learn more about the cryptocurrency universe
        </h2>
        <h3 class="text">
          Cryptodeu is the easiest place to find out about cryptocurrencies.
          sign up and get started today.
        </h3>
        <div class="inbtn">
          <input type="text" placeholder="Email Address" />
          <button class="cta-btn">Get Started</button>
        </div>
      </div>

      <div class="image-section">
        <svg
          width="580"
          height="656"
          viewBox="0 0 680 956"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="HeroVariant__DefaultHeroImage-sc-1o7093z-6 fNmrnO"
        >
          <circle cx="340" cy="428" r="340" fill="#F1F5FE"></circle>
          <g filter="url(#prefix__filter0_dd)">
            <path
              d="M481 10H198c-32.032 0-58 25.968-58 58v720c0 32.032 25.968 58 58 58h283c32.032 0 58-25.968 58-58V68c0-32.032-25.968-58-58-58z"
              fill="url(#prefix__paint0_linear)"
            ></path>
            <path
              d="M472.489 22H206.511C176.406 22 152 47.222 152 78.335v699.33C152 808.778 176.406 834 206.511 834h265.978C502.594 834 527 808.778 527 777.665V78.335C527 47.222 502.594 22 472.489 22z"
              fill="url(#prefix__img1)"
            ></path>
            <g filter="url(#prefix__filter1_f)">
              <path
                d="M213.5 15.5c-38.883 0-67.5 23.943-67.5 61.343V783.5c0 20.5 11.5 57 65.5 57"
                stroke="url(#prefix__paint1_radial)"
              ></path>
            </g>
            <g filter="url(#prefix__filter2_f)">
              <path
                d="M465.5 15c38.883 0 67.5 23.943 67.5 61.343V783c0 20.5-11.5 57-65.5 57"
                stroke="url(#prefix__paint2_radial)"
              ></path>
            </g>
          </g>
          <defs>
            <filter
              id="prefix__filter0_dd"
              x="48"
              y="0"
              width="519"
              height="956"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx="-32" dy="50"></feOffset>
              <feGaussianBlur stdDeviation="30"></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0.321569 0 0 0 0 0.321569 0 0 0 0 0.321569 0 0 0 0.25 0"
              ></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="15"></feOffset>
              <feGaussianBlur stdDeviation="7.5"></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0.320833 0 0 0 0 0.320833 0 0 0 0 0.320833 0 0 0 0.1 0"
              ></feColorMatrix>
              <feBlend
                in2="effect1_dropShadow"
                result="effect2_dropShadow"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect2_dropShadow"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="prefix__filter1_f"
              x="143.5"
              y="13"
              width="72"
              height="830"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur"
              ></feGaussianBlur>
            </filter>
            <filter
              id="prefix__filter2_f"
              x="463.5"
              y="12.5"
              width="72"
              height="830"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur"
              ></feGaussianBlur>
            </filter>
            <radialGradient
              id="prefix__paint1_radial"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(286.75008 212.24974 -632.54832 854.57482 179.75 390.25)"
            >
              <stop stop-opacity="0.2"></stop>
              <stop offset="1" stop-opacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="prefix__paint2_radial"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(0 756.5 -2254.52 0 499 131)"
            >
              <stop stop-opacity="0"></stop>
              <stop offset="0.453" stop-opacity="0.2"></stop>
              <stop offset="1" stop-opacity="0"></stop>
            </radialGradient>
            <linearGradient
              id="prefix__paint0_linear"
              x1="539"
              y1="654"
              x2="-169.5"
              y2="799.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#000"></stop>
              <stop offset="0.64" stop-color="#000"></stop>
            </linearGradient>
            <pattern
              id="prefix__img1"
              patternUnits="objectBoundingBox"
              width="1"
              height="1"
              viewBox="0 0 375 812"
            >
              <image
                href="https://blockfolio.com/static/media/invest@2x.8ab55e47.png"
                width="375"
                height="812"
              ></image>
            </pattern>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
};
</script>

<style scoped>
.hero-section {
  padding-top: 3em;
  padding-bottom: 8em;
}
.hero-container {
  width: 88%;
  margin: 0 auto;
}
.image-section {
  display: none;
}
.bitcoin {
  color: #e19a3c;
  font-weight: 900;
  display: flex;
  align-items: center;
  margin-top: 80px;
}
.bitcoin p {
  margin: 0 10px 0;
}
.heading {
  font-size: 2rem;
  width: 300px;
  line-height: 1.15;
  font-weight: 800px;
  margin-top: 15px;
}
.text {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  width: 320px;
  margin-top: 15px;
  text-align: left;
}
.inbtn {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.inbtn input {
  width: 100%;
  font-family: inherit;
  padding: 10px;
  height: 60px;
  border-radius: 4px;
  border: 1px solid gainsboro;
  font-size: 18px;
}
.cta-btn {
  height: 60px;
  background-color: rgb(255, 166, 0);
  color: white;
  font-weight: 800;
  display: block;
  border: 1px solid rgb(255, 196, 0);
  width: 100%;
  border-radius: 4px;
  font-family: inherit;
  font-size: 16px;
  margin-top: 10px;
}

@media only screen and (min-width: 992px) {
  .hero-section {
    padding-bottom: 0;
  }
  .hero-container {
    width: 80%;
    display: flex;
    justify-content: space-between;
  }
  .image-section {
    display: block;
    margin-left: 120px;
  }

  .heading {
    font-size: 2.5rem;
    width: 600px;
  }
  .text {
    font-size: 20px;
    line-height: 1.4;
    font-weight: 800;
    width: 450px;
  }
  .inbtn {
    flex-direction: row;
  }

  .inbtn input {
    width: 240px;
  }
  .cta-btn {
    width: 200px;
    margin-left: 10px;
    border-radius: 4px;
    margin-top: 0;
  }
}
</style>